<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('create_relocation.new') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-row class="px-5 py-0 my-0" justify="center" align="center">
                        <v-col cols="6" class="py-0">
                            <client-selector :addAllOption="false" class="py-0 my-0 " ref="clientSelector" @getClients="v => items.clients = v" :is_national="2"></client-selector>  
                        </v-col>
                    </v-row>
                        
                    <v-form ref="form" lazy-validation @submit.prevent="addSku">
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-autocomplete class="py-0" v-model="location_id" :loading="locations_load" item-value="id" item-text="name" :items="locations" :label="$t('create_relocation.origin_location')" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>

                    <v-row class="px-5 py-0" justify="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('create_relocation.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save" v-permission="'relocation.create'">
                                {{ $t('create_relocation.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { HttpRelocationRepository } from '../infrastructure/repositories/relocation_repository';
import { relocateAllInlocationUseCase } from '../application/use_cases/relocate_all_in_location_use_case';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
        headers: function (){
            return [
                { text: this.$t('create_relocation.sku_'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('create_relocation.pallet'), align: "center", value: 'pallet', class: 'text-uppercase' },
                { text: this.$t('create_relocation.quantity'), align: "center", value: 'quantity', class: 'text-uppercase' },
                { text: this.$t('create_relocation.batch'), align: "center", value: 'batch', class: 'text-uppercase' },
                { text: this.$t('create_relocation.expiration'), align: "center", value: 'reference', class: 'text-uppercase' },
                { text: this.$t('create_relocation.origin'), align: "center", value: 'origin_location_name', class: 'text-uppercase' },
                { text: this.$t('create_relocation.destination'), align: "center", value: 'destination_location_name', class: 'text-uppercase' },
                { text: "", align: "center", value: 'actions', class: 'text-uppercase' }
            ];
        }
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            }, 
            location_id: "",
            locations: [],
            locations_load: false,
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.create_relocation";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        index(){},
        async save(){
            try{
                const response = await relocateAllInlocationUseCase(this.location_id, HttpRelocationRepository);
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: response.data.success.message
                }

                this.$router.go(-1);                  
            } catch (e) {
                console.log(e.response);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        }
    },
    watch: {
        "$store.state.clientId": function(){
            const lsToken = localStorage.getItem("access_token");
            this.destination_locations_load = true;
            this.locations = [];
            this.destination_locations = [];

            this.$http.get(this.$store.state.chronosApi + 'relocations/get_locations?client_id=' + this.$store.state.clientId + '&occupied=true', {headers: {Authorization: lsToken}})
            .then((response) => {
                this.locations = response.data.data;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.locations_load = false;
                this.$store.state.loaderProps.visible = false;
            })
        }
    }
}
</script>

<style lang="css">
</style>
